import React from 'react'

const SpecificTriggerRuleError = ({ error }: { error: string }) =>
  error ? (
    <div
      className={
        'bg-brand-primary/30 border-brand-primary text-text-primary rounded-lg border p-5 '
      }
    >
      {error}
    </div>
  ) : null

export default SpecificTriggerRuleError
